export default {
  getEmployee: (state) => state.employee,
};
